<mat-tab-group>
  <mat-tab label="Create"> </mat-tab>
</mat-tab-group>
  <p class="common-info">
    <a class="nav-back" routerLink="/workspaces/template" aria-label="Go back to template list">
      <mat-icon>arrow_back</mat-icon>
    </a>
   Create a template with the initial version number
  </p>
<app-template-form
    [loading]="loading"
    submitButtonText="Save"
    (formSubmit)="onSubmit($event)">
</app-template-form>
